import {
  Animated,
  Share,
  Dimensions,
  SafeAreaView,
  ScrollView,
  Text,
  Pressable,
  View,
  TouchableOpacity,
  ActivityIndicator,
  StatusBar,
  Image,
} from "react-native";
import React from "react";
import { useEffect, useRef, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import Navbar from "../../components/Navbar/Navbar";
import { styles } from "./styles/styles";
import LikeModal from "../../modal/FeedModals/ActionModals/LikeModal";
import RejectProfile from "../../modal/FeedModals/ActionModals/RejectProfile";
import ProfileCard from "./HomeFeedComponents/ProfileCard";
import UserProfileDetails from "./HomeFeedComponents/UserProfileDetails";
import UserExperiences from "./HomeFeedComponents/UserExperiences";
import NextProfileButton from "./HomeFeedComponents/NextProfileButton";
import MatchModal from "../../modal/FeedModals/ActionModals/MatchModal";
import ShowLikeModal from "../../modal/FeedModals/ActionModals/ShowLikeModal";
import ReportModal from "../../modal/FeedModals/ActionModals/ReportModal";
import GlobalStyles from "../../globalStyles/globalStyles";
import { Colors } from "../../globalStyles/ColorConfig";
import Brand from "../../assets/Icons/BrandIcons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import {
  getMatchMakerFeed,
  matchEdit,
} from "../../services/MatchMaker/matchMakerServices";
import { reportUser } from "../../services/MatchMaker/matchMakerServices";
import { getUser } from "../../services/ProfileSettings/ProfileSettingService";
import ExperienceIcons from "../../assets/Icons/ExperienceIcons";
import { getUserBooking } from "../../services/DateMode/DateModeServices";
import FeedIcons from "../../assets/Icons/FeedIcons";
import StaticImages from "../../assets/StaticImages";
import { LinearGradient } from "expo-linear-gradient";
interface Profile {
  _id: string;
  photos: Array<string>;
  age: number;
  bio: string;
  gender: string;
  userInfo: {
    height: string;
    drinker: boolean;
    smoker: boolean;
    ethnicity: string;
    currentPosition: string;
    educationLevel: string;
    relationshipStatus: string;
  };
  preferences: {
    seeking: string;
  };
  isVerified: boolean;
  firstName: string;
  interestedExperiences: any[];
}

export default function HomeFeed() {
  const [user, setUser] = useState(null);
  const navigation = useNavigation();
  const height = Dimensions.get("window").height;
  const [profiles, setProfiles] = useState<Profile[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [index, setIndex] = useState(0);
  const [likeType, setLikeType] = useState("like");
  const [likedImage, setLikedImage] = useState(null);
  const [isModalVisible, setModalVisible] = useState(false);
  const [isRejectModalVisible, setRejectModalVisible] = useState(false);
  const [isMatchModalVisible, setMatchModalVisible] = useState(false);
  const [isShowLikeModalVisible, setShowLikeModalVisible] = useState(false);
  const [isBooking, setIsBooking] = useState<any | null>(null);
  const [likedExpId, setLikedExpId] = useState("");
  const [report, setReport] = useState(false);
  const [reason, setReason] = useState("");
  const [page, setPage] = useState(1); // Default page number
  const [pageSize, setPageSize] = useState(30);
  const [otherName, setOtherName] = useState("");
  const scrollViewRef = useRef(null);
  useEffect(() => {
    const fetchUser = async () => {
      const response = await getUser();
      console.log("user", response?.data);
      setUser(response?.data);

      // Check if filters exist in storage
      const storedFilters = await AsyncStorage.getItem("filters");
      const initialFilters = storedFilters ? JSON.parse(storedFilters) : null;
      if (initialFilters) {
        setFilters(initialFilters);
        // fetchData();
      } else {
        setFilters((prev: any) => {
          const updatedFilters = {
            ...prev,
            basicFilters: {
              ...prev.basicFilters,
              ageRange: {
                min: response?.data?.age > 40 ? 30 : 18,
                max: response?.data?.age > 40 ? 50 : 60,
              },
              gender: response?.data?.preferences.gender || [],
              language: response?.data?.preferences.language || [],
              minDistance: 0,
              maxDistance: 100,
            },
            advanceFilters: {
              ...prev.advanceFilters,
              isVerified: response?.data?.preferences.isVerified || true,
              experienceInterestedIn:
                response?.data?.interestedExperiences || [],
              bodyType: response?.data?.userInfo.bodyType
                ? [response?.data?.userInfo.bodyType]
                : [],
              ethnicity: response?.data?.userInfo.ethnicity
                ? [response?.data?.userInfo.ethnicity]
                : [],
              seeking: response?.data?.preferences.seeking || "",
              educationLevel: response?.data?.userInfo.educationLevel
                ? [response?.data?.userInfo.educationLevel]
                : "",
              relationshipStatus: response?.data?.userInfo.relationshipStatus
                ? [response?.data?.userInfo.relationshipStatus]
                : "",
            },
          };

          // Save the updated state to AsyncStorage
          AsyncStorage.setItem("filters", JSON.stringify(updatedFilters));

          return initialFilters || updatedFilters;
        });
      }
    };

    fetchUser();
  }, []);

  const [filters, setFilters] = useState({
    basicFilters: {
      gender: [],
      ageRange: {
        min: "",
        max: "",
      },
      language: [],
      maxDistance: "",
      minDistance: "",
    },
    advanceFilters: {
      isVerified: "",
      experienceInterestedIn: [],
      // heightRange: {
      //   min: "",
      //   max: "",
      // },
      bodyType: [],
      // location: {
      //   latitude: "",
      //   longitude: "",
      // },
      ethnicity: [],
      educationLevel: [],
      relationshipStatus: "",
      seeking: [],
      // children: "",
      // smoker: "",
      // drinker: "",
    },
  });
  const toggleShowLikeModal = () => {
    setShowLikeModalVisible(!isShowLikeModalVisible);
  };

  const handleFiltersChange = (updatedFilters: any) => {
    setFilters(updatedFilters);
    // Optionally, you can trigger a refetch or apply the filters here
  };

  const currentProfile = profiles && profiles[currentIndex];

  const [viewableItems, setViewableItems] = useState([]);
  const handleOnViewableItemsChanged = useRef(
    ({ viewableItems }: { viewableItems: any }) => {
      setViewableItems(viewableItems);
      setIndex(viewableItems[0].index);
    }
  ).current;

  const viewabilityConfig = useRef({
    itemVisiblePercentThreshold: 50,
  }).current;

  const toggleModal = () => {
    setModalVisible(!isModalVisible);
  };

  const toggleRejectModal = () => {
    setRejectModalVisible(!isRejectModalVisible);
  };

  const handleLikePress = (type: any, image: any, experienceId: any) => {
    if (type === "experienceLike") {
      setLikedExpId(experienceId);
    }
    toggleModal();
    setLikeType(type);
    setLikedImage(image);
  };

  const handleNextProfile = async () => {
    // Increment the index to show the next profile
    rejectProfile();
    toggleRejectModal();
    scrollViewRef.current?.scrollTo({ x: 0, y: 0, animated: true });

    // Check if there are no more profiles left
    if (currentIndex === profiles.length - 1) {
      // Fetch the next page of profiles
      const nextPage = page + 1;
      const data = await getMatchMakerFeed(
        JSON.stringify({ ...filters, page: nextPage, pageSize })
      );
      const response = await data?.json();
      if (response.status === 200) {
        // Append the new profiles to the existing list
        setProfiles([...profiles, ...response.data]);
      }
    }
  };

  const handleLikeNextProfile = () => {
    setCurrentIndex(currentIndex + 1);
  };
  const rejectProfile = async () => {
    try {
      // Get the profile ID of the rejected user
      const rejectedProfileId = currentProfile._id;
      const requestBody = {
        disliked: [rejectedProfileId],
      };
      const responseData = await matchEdit(JSON.stringify(requestBody));
      setCurrentIndex(currentIndex + 1);
      console.log("Reject response:", responseData);
    } catch (error) {
      console.error("Reject edit failed:", (error as Error).message);
      // Handle the error as needed
    }
  };
  const eportFunction = async () => {
    const body = {
      reason: reason,
      reportedId: currentProfile._id,
    };
    const reportUpdate = await reportUser(body);
    console.log(body);
    setReport(false);
  };

  const [showExpandMessage, setShowExpandMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [nonSubscribed, setNonSubscribed] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (filters.advanceFilters.isVerified != "") {
        const data = await getMatchMakerFeed(
          JSON.stringify({ ...filters, page, pageSize })
        );
        const response = await data?.json();
        console.log("response", response);

        if (response.status === 200) {
          setProfiles(response?.data);
          setShowExpandMessage(null);
        } else if (response.status === 201) {
          setShowExpandMessage(response?.message);
        } else if (
          response.status === 403 ||
          response.message === "Please subscribe to skip the waiting list!"
        ) {
          setNonSubscribed(true);
        }

        setLoading(false);
      }
    };

    fetchData();
  }, [filters.advanceFilters, filters.basicFilters]);

  useEffect(() => {
    console.log("====================================");
    console.log("filters changed", filters);
    console.log("====================================");
  }, [filters]);

  useEffect(() => {
    // const fetchBookingData = async () => {
    //   const data = await getUserBooking();
    //   if (data?.data?.length > 0) {
    //     console.log();
    //     setIsBooking(data?.data[0]);
    //   }
    //   console.log("booking", data);
    //   const otherid = user?._id === participants[0];
    // };
    // fetchBookingData();
  }, []);

  const features = [
    {
      text: "See who likes you",
    },

    {
      text: "Unlimited likes",
    },

    {
      text: "Enhanced recommendations",
    },

    {
      text: "Direct message",
    },
    {
      text: "See who like you",
    },
  ];

  return (
    <>
      <StatusBar
        translucent
        backgroundColor={"transparent"}
        barStyle={"dark-content"}
      />
      <SafeAreaView style={styles.FeedContainer}>
        <ScrollView ref={scrollViewRef}>
          <ReportModal
            isVisible={report}
            toggleModal={() => setReport(!report)}
            method1={eportFunction}
            method3={(text: string) => {
              setReason(text);
            }}
          />
          <LikeModal
            isVisible={isModalVisible}
            toggleModal={toggleModal}
            likedImage={likedImage}
            likeType={likeType}
            targetId={currentProfile?._id}
            experienceId={likedExpId}
            setMatchModalVisible={setMatchModalVisible}
            matchModalVisible={isMatchModalVisible}
            setsShowLikeModalVisible={setShowLikeModalVisible}
            handleLikeNextProfile={handleLikeNextProfile}
          />
          <RejectProfile
            isVisible={isRejectModalVisible}
            toggleModal={toggleRejectModal}
            from="feed"
          />
          <MatchModal
            isVisible={isMatchModalVisible}
            toggleModal={() => {
              setMatchModalVisible(!isMatchModalVisible);
            }}
            photos={currentProfile?.photos[0]}
            interests={currentProfile}
            receiverId={currentProfile?._id}
          />
          <ShowLikeModal
            isVisible={isShowLikeModalVisible}
            toggleModal={toggleShowLikeModal}
          />
          <Navbar
            filters={filters}
            setFilters={setFilters}
            handleFiltersChange={handleFiltersChange}
          />
          {nonSubscribed === true ? (
            <>
              <View style={styles.ScreenWrapper}>
                <View style={styles.WaitingListCard}>
                  <View
                    style={{
                      position: "absolute",
                      top: "-50%",
                      right: 16,
                    }}
                  >
                    <FeedIcons.Stars />
                  </View>
                  <Text style={styles.WaitingList}>
                    405
                    <Text style={styles.WaitingListSecondary}>/405</Text>
                  </Text>
                  <Text
                    style={[
                      GlobalStyles.heading3,
                      {
                        color: "#F3EAE1",
                        marginTop: 16,
                        marginBottom: 8,
                      },
                    ]}
                  >
                    are waiting in Bangkok
                  </Text>
                  <Text
                    style={[
                      GlobalStyles.bodyText,
                      {
                        color: "#F3EAE1",

                        textAlign: "center",
                      },
                    ]}
                  >
                    We waitlist to maintain a balanced, highly-engaged & diverse
                    community
                  </Text>
                  <View style={styles.flexJustify}>
                    <ExperienceIcons.WayLine />
                    <Text
                      style={[
                        GlobalStyles.captionText,
                        {
                          color: "#F3EAE1",
                          textAlign: "center",
                          textTransform: "uppercase",
                          // capatilize
                        },
                      ]}
                    >
                      Don’t do queues?
                    </Text>
                    <ExperienceIcons.WayLine />
                  </View>

                  <TouchableOpacity
                    style={[
                      GlobalStyles.primaryButton,
                      {
                        backgroundColor: "#C0A46F",
                        marginBottom: 8,
                      },
                    ]}
                  >
                    <Text
                      style={[
                        GlobalStyles.ctaText,
                        {
                          color: "#FDFBF9",
                        },
                      ]}
                    >
                      Become our member
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity>
                    <Text
                      style={[
                        GlobalStyles.ctaText,
                        {
                          paddingVertical: 16,
                          color: "#C0A46F",
                        },
                      ]}
                    >
                      Use Referral Code
                    </Text>
                  </TouchableOpacity>
                </View>
                <View style={styles.seperation}>
                  <ExperienceIcons.WayLine />
                </View>
                <View>
                  <Text
                    style={[
                      GlobalStyles.title1,
                      {
                        marginBottom: 16,
                      },
                    ]}
                  >
                    See who all are waiting for you
                  </Text>
                  <View style={styles.HomeDisplayCards}>
                    <View style={styles.HomeDisplayCard}>
                      <Image
                        source={StaticImages.Display}
                        style={styles.HomeDisplayCardImg}
                      />
                      {/* <View style={styles.HomeDisplayCardGradient}>
                  <Icons.WhiteGradient />
                </View> */}
                      <LinearGradient
                        colors={["transparent", "rgba(255,255,255,1)"]}
                        style={[
                          styles.HomeDisplayCardInfo,
                          {
                            paddingHorizontal: 14,
                          },
                        ]}
                      >
                        <View style={styles.HomeDisplayCardInfo}>
                          <View>
                            <View style={styles.BadgeLabel}>
                              <Text
                                style={[
                                  GlobalStyles.heading2,
                                  {
                                    lineHeight: 33,
                                  },
                                ]}
                              >
                                Adisorn
                              </Text>
                              <FeedIcons.VerifiedBadge />
                            </View>
                            <Text style={GlobalStyles.bodyText}>
                              Active now
                            </Text>
                          </View>
                        </View>
                      </LinearGradient>
                    </View>
                    <View style={styles.HomeDisplayCard}>
                      <Image
                        source={StaticImages.Display2}
                        style={styles.HomeDisplayCardImg}
                      />
                      {/* <View style={styles.HomeDisplayCardGradient}>
                  <Icons.WhiteGradient />
                </View> */}
                      <LinearGradient
                        colors={["transparent", "rgba(255,255,255,1)"]}
                        style={[
                          styles.HomeDisplayCardInfo,
                          {
                            paddingHorizontal: 14,
                          },
                        ]}
                      >
                        <View style={styles.HomeDisplayCardInfo}>
                          <View>
                            <View style={styles.BadgeLabel}>
                              <Text
                                style={[
                                  GlobalStyles.heading2,
                                  {
                                    lineHeight: 33,
                                  },
                                ]}
                              >
                                Abena
                              </Text>
                              <FeedIcons.VerifiedBadge />
                            </View>
                            <Text style={GlobalStyles.bodyText}>
                              Active now
                            </Text>
                          </View>
                        </View>
                      </LinearGradient>
                    </View>
                  </View>
                </View>
                <View style={styles.seperation}>
                  <ExperienceIcons.WayLine />
                </View>
                <View style={styles.LogoContainer}>
                  <View style={styles.LogoContainerIcon}>
                    <Brand.BlackLogo />
                  </View>
                  <Text
                    style={[
                      GlobalStyles.heading3,
                      {
                        textAlign: "center",
                        fontSize: 20,
                      },
                    ]}
                  >
                    Subscribers go on twice as many dates.
                  </Text>
                </View>
                <View>
                  {features.map((item, index) => {
                    return (
                      <View key={index} style={styles.SubscriptionFeature}>
                        <Text
                          style={[
                            GlobalStyles.bodyText,
                            { paddingVertical: 16 },
                          ]}
                        >
                          {item.text}
                        </Text>
                        <FeedIcons.Tick />
                      </View>
                    );
                  })}
                  <Text
                    style={[GlobalStyles.bodyText, { paddingVertical: 16 }]}
                  >
                    and more ...
                  </Text>
                </View>
                <View
                  style={{
                    alignItems: "center",
                    display: "flex",
                    marginBottom: 20,
                    marginTop: 10,
                  }}
                >
                  <TouchableOpacity
                    style={[
                      GlobalStyles.primaryButton,
                      {
                        backgroundColor: Colors.darkGreen,
                        marginBottom: 8,
                      },
                    ]}
                  >
                    <Text
                      style={[
                        GlobalStyles.ctaText,
                        {
                          color: "#FDFBF9",
                        },
                      ]}
                    >
                      Become our member
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity>
                    <Text
                      style={[
                        GlobalStyles.ctaText,
                        {
                          paddingVertical: 16,
                          color: "#000",
                        },
                      ]}
                    >
                      Use Referral Code
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </>
          ) : (
            <>
              {loading ? (
                <View style={styles.loadingIndicator}>
                  <ActivityIndicator size="large" />
                </View>
              ) : showExpandMessage || profiles?.length === 0 ? (
                <>
                  <View
                    style={{
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      width: "90%",
                      height: "100%",
                      marginHorizontal: "5%",
                      marginTop: 150,
                    }}
                  >
                    <View
                      style={{
                        opacity: 0.7,
                        transform: [{ scale: 1.4 }],
                      }}
                    >
                      <Brand.GoldIcon />
                    </View>
                    <Text
                      style={{
                        color: Colors.black70,
                        fontSize: 20,
                        fontFamily: "EBGaramondBold",
                        textAlign: "center",
                        marginTop: 10,
                      }}
                    >
                      {showExpandMessage && showExpandMessage}
                    </Text>
                  </View>
                </>
              ) : (
                <>
                  <ProfileCard
                    currentProfile={currentProfile}
                    height={height}
                    index={index}
                    // handleOnScroll={handleOnScroll}
                    handleOnViewableItemsChanged={handleOnViewableItemsChanged}
                    handleLikePress={handleLikePress}
                    viewabilityConfig={viewabilityConfig}
                    fromHomeFeed={true}
                  />

                  <UserProfileDetails currentProfile={currentProfile} />

                  <UserExperiences
                    currentProfile={currentProfile}
                    handleLikePress={handleLikePress}
                    interest={false}
                    fromHomeFeed={true}
                  />

                  <TouchableOpacity
                    style={styles.reportButton}
                    onPress={() => setReport(true)}
                  >
                    <Text style={GlobalStyles.bodyText}>Report Profile</Text>
                  </TouchableOpacity>
                </>
              )}
            </>
          )}
        </ScrollView>
        {showExpandMessage || profiles?.length === 0 ? null : (
          <NextProfileButton handleNextProfile={handleNextProfile} />
        )}
      </SafeAreaView>
    </>
  );
}
